import {useState} from 'react';

import clampEntryName from 'notebook/entry-templates/clampEntryName';

export interface AnalysisTemplateNameState {
  name: string;
  trimmedName: string;
  isNameBlank: boolean;
  nameError: string | null;

  setName: (name: string) => void;
}

export function useAnalysisTemplateNameState(initialName: string): AnalysisTemplateNameState {
  const [name, setName] = useState(clampEntryName(initialName));

  const trimmedName = name.trim();
  const isNameBlank = trimmedName === '';

  return {
    name,
    trimmedName,
    isNameBlank,
    nameError: isNameBlank ? 'Template name must be non-empty.' : null,

    setName: (newName) => {
      setName(clampEntryName(newName));
    },
  };
}
